import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const eventClientList = (request) => {     
    let ENDPOINT = URL_BASE_API+'user/client-name-list/';
    if(request.data!==undefined){ 
        let search   = request.data.search;
        let pageId   = request.data.page;
        let column   = request.data.column;   
        let pageSize = request.data.pageSize;   
        if(column||pageId||search||pageSize){
            ENDPOINT += '?page='+pageId+'&column='+column+'&search='+search+'&page_size='+pageSize;
        }          
    }
    return service.get(ENDPOINT);  
}; 

export const clientList = (request) => {     
    let ENDPOINT = URL_BASE_API+'user/client-list/';
    if(request.data!==undefined){ 
        let search   = request.data.search;
        let pageId   = request.data.page;
        let column   = request.data.column;   
        let pageSize = request.data.pageSize;   
        if(column||pageId||search||pageSize){
            ENDPOINT += '?page='+pageId+'&column='+column+'&search='+search+'&page_size='+pageSize;
        }   

        let applyFilter=0; 
        if(request.data.filterApplied && Number(request.data.filterApplied) > 0 && request.data.filtersData) {
            let filtersData = request.data.filtersData;
            if(filtersData.statusActive && filtersData.statusActive!='') {
                ENDPOINT += '&status='+filtersData.statusActive;
                applyFilter=1; 
            }

            if(filtersData.includeDate) { 
                ENDPOINT += '&from_date='+filtersData.selectedStartDate+'&to_date='+filtersData.selectedEndDate;
                applyFilter=1; 
            }
            if(filtersData.categories && filtersData.categories.length>0) { 
                ENDPOINT += '&categories='+JSON.stringify(filtersData.categories);
                applyFilter=1; 
            } 
            
            if(applyFilter) ENDPOINT += '&filter='+applyFilter; 
        }
    }
    return service.get(ENDPOINT);  
    
}; 

export const clientQuickAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'user/client-profile/?quick_add=true';
  
    return service.post(ENDPOINT,request.data);  
    
}; 

export const clientEdit = (request) => {
    let clientId = request.data;
    const ENDPOINT = URL_BASE_API+'user/client-update/'+clientId;
  
    return service.get(ENDPOINT);  
    
}; 

export const clientCompanyInfoAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'user/client-profile/';
  
    return service.post(ENDPOINT,request.data);
    
}; 

export const clientPrmryConctAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'user/client-primary/';
  
    return service.post(ENDPOINT,request.data);
    
}; 

export const clientCompanyInfoUpdate = (request) => {
    let clientId   = request.data.get('id');
    const ENDPOINT = URL_BASE_API+'user/client-update/'+clientId;
    request.data.delete('id');

    return service.put(ENDPOINT,request.data);  
    
}; 

export const clientPrimaryContactUpdate = (request) => {
    let profileId = request.data.profileId;
    let userType = request.data.userType;
    if(request.data.hasOwnProperty('associate_id')){
        const ENDPOINT = URL_BASE_API+'user/primary-contacts/?user_type='+userType+'&profile_id='+profileId;
        delete request.data.profileId; 
        delete request.data.userType; 
        return service.post(ENDPOINT,request.data); 
    }
}; 


export const clientActiveDeactive = (request) => {
    let clientId = request.data.profileId;
    const ENDPOINT = URL_BASE_API+'user/client-active-status/'+clientId;
    delete request.data.profileId;
    return service.put(ENDPOINT,request.data);   
};

export const clientContactList = (request) => {  
    let clientId = request.data.clientId; 
    let column   = request.data.column;
    let ENDPOINT = URL_BASE_API+'user/list-associates/?client_id='+clientId+'&column='+column;
    
    return service.get(ENDPOINT);  
    
};


export const clientContactAdd = (request) => {  
    let ENDPOINT = URL_BASE_API+'user/client-add-contacts/';
    
    return service.post(ENDPOINT,request.data);  
    
};

export const clientRateCardList = (request) => {  
    // let clientId = request.data;   
    // let ENDPOINT = URL_BASE_API+'affiliate/client-master-card/?client='+clientId+'&column=skill_name';
    let clientId = request.data.clientId;  
    let affiliateId = request.data.affiliateId;  
    let ENDPOINT = URL_BASE_API+'affiliate/client-master-card/?affiliate='+affiliateId+'&client='+clientId+'&column=skill_name';
    return service.get(ENDPOINT); 
};

export const clientRateCardUpdate = (request) => {  
    let clientId = request.data.clientId;   
    delete request.data.clientId;
    let ENDPOINT = URL_BASE_API+'affiliate/client-master-card/?client='+clientId;
    return service.put(ENDPOINT,request.data); 
};

export const clientCsvImport = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/import-client-crew/';
    return service.post(ENDPOINT,request.data);   
};

export const clientCsvQuickFileImport = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/import-client-quick-file/';
    return service.post(ENDPOINT,request.data);   
};

export const clientContactCsvImport = (request) => {
    const ENDPOINT = URL_BASE_API+'user/import-client-contacts/';
    return service.post(ENDPOINT,request.data);   
};

export const clientGetCrewChiefBonus = (request) => {
    let clientId = request.data;
    const ENDPOINT = URL_BASE_API+'user/client-chief-bonus/?client_id='+clientId;
    return service.get(ENDPOINT);  
}; 

export const clientUpdateCrewChiefBonus = (request) => {  
    let clientId = request.data.clientId;   
    delete request.data.clientId;
    let ENDPOINT = URL_BASE_API+'user/client-chief-bonus/?client_id='+clientId;
    return service.put(ENDPOINT,request.data); 
};

export const clientContactDelete = (request) => {
    const ENDPOINT = URL_BASE_API+'user/associate-user/'+request.data;
    return service.delete(ENDPOINT);   
};

export const clientCategoryList = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/client-category_v2/?page=0&column=name';
    return service.get(ENDPOINT); 
};

export const clientListForCategories = (request) => {
    let categories = request.data.selectedCategory
    let clientId = request.data.clientId
    const ENDPOINT = URL_BASE_API+'user/categorized-clients/?page=0&client_id='+clientId+'&categories='+JSON.stringify(categories);
    return service.get(ENDPOINT); 
};

export const clientFullList = (request) => {
    const ENDPOINT = URL_BASE_API+'user/client-full-list/?column=company_name&company_name='+request.data;
    return service.get(ENDPOINT); 
};

export const clientBasicInfo = (request) => {
    const ENDPOINT = URL_BASE_API+'user/client-basic-info/?id='+request.data;
    return service.get(ENDPOINT);
};

export const clientDepartmentsByClientId = (request) => { // USED IN SHIFT ADD/EDIT FROM CLIENT LOGIN
    let clientId = request.data.clientId;
    let affiliateId = request.data.affiliateId;
    const ENDPOINT = URL_BASE_API+'user/client-departments/?client_id='+clientId+'&affiliate='+affiliateId;  
    return service.get(ENDPOINT);
};